module.exports = __webpack_public_path__ + "static/media/噪音.12451483.svg";